import React from "react";
import ReactDOM from "react-dom";
import DCRForm from "./DCRForm";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./componenets/ErrorBoundary";
import "./index.scss";
import { StateProvider } from "./state/State";
import { initialState } from "./state/InitialState";
import { reducer as errorReducer } from "./state/ErrorReducer";

//// SAMPLE: FORM SERVER SAMPLE OBJECT

/* window.formserverConfigs = {
   containerId: "formserver",
   errorContainerId: "formserver-error",
   onSubmit: (graphXML) => console.log("cb_ok", graphXML),
   onUpdate: (graphXML) => console.log("cb_update", graphXML),
   onCancel: (graphXML) => console.log("cb_cancel", graphXML),
 }; */

let rootElemetId = "root";
function initFormserverConfigs() {
  if (!window.formserverConfigs) window.formserverConfigs = {};
  if (window.formserverConfigs.containerId) {
    const { containerId } = window.formserverConfigs;
    console.log("containerId", containerId);
    const container = document.getElementById(containerId);
    if (container) {
      rootElemetId = containerId;
    }
  }
}

initFormserverConfigs();

function renderFormServer(config) {
  const { containerId, graph } = config || {};
  const container = document.getElementById(containerId);
  if (container) {
    ReactDOM.render(
      <StateProvider initialState={initialState} reducer={errorReducer}>
        <React.StrictMode>
          <ErrorBoundary>
            <DCRForm {...config} />
          </ErrorBoundary>
        </React.StrictMode>
      </StateProvider>,
      container,
      () => {
        if (graph) {
          setTimeout(() => events.fire("loadDynamicForm", graph), 0);
        }
      }
    );
  }
}

renderFormServer({containerId: rootElemetId});

function unMountFormServer(containerId) {
  const container = document.getElementById(containerId);
  if (container) {
    ReactDOM.unmountComponentAtNode(container);
  }
}

const { events } = window || {};

if (events) {
  if (!events?.events?.loadFormServer) {
    events.on('loadFormServer', (config) => {
      renderFormServer(config);
    });
  }
  if (!events?.events?.unMountFormServer) {
    events.on('unMountFormServer', (containerId) => {
      unMountFormServer(containerId);
    });
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
